import { Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import theme from "../../theme";
import CloseIcon from "@mui/icons-material/Close";
import ScanQrImage from "../../assets/ScanQrFail.svg";

interface PropType {
  closeDrawer: Function;
  resetScanner : Function;
}

const ScannerModalFail = (props: PropType) => {
  const { closeDrawer , resetScanner } = props;
  return (
    <Grid
      sx={{
        background: theme.color?.background,
        width: "35%",
        height: "80%",
        borderRadius: "16px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        // justifyContent: "center",
        alignItems: "center",
      }}
      p={3}
    >
      <Grid width={"100%"} display={"flex"} justifyContent={"end"}>
        <IconButton
          aria-label="delete"
          onClick={() => {
            closeDrawer(false);
            resetScanner(false);
          }}
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      <Typography
        sx={{
          font: theme.font?.fontFamily.primary,
          fontSize: theme.font?.fontSize.large,
          fontWeight: theme.font?.fontWeight.thick,
          textAlign: "center",
        }}
        px={5}
        py={"1vh"}
      >
        There was an error while scanning the QR Code. Please try again
      </Typography>
      <Grid height={"60%"} display={"flex"} alignItems={"center"}>
        <img
          src={ScanQrImage}
          alt="QR Code"
          //   width={200}
          //   height={200}
        />
      </Grid>
      <Typography
        sx={{
          font: theme.font?.fontFamily.primary,
          fontSize: theme.font?.fontSize.tableHeader,
          fontWeight: theme.font?.fontWeight.slightThick,
          color: theme.color?.newGreyText,
        }}
        mt={1}
      >
        Hold your device over QR code to scan it.
      </Typography>
    </Grid>
  );
};

export default ScannerModalFail;
